export const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY';

export const DATE_PARSE_FORMATS = [
  'DD/MM/YYYY',
  'D/M/YYYY',
  'YYYY-MM-DD',
  'DD-MM-YYYY',
  'MM/DD/YYYY',
];

export const MULTIDATE_SEPARATOR = ' | ';
